import React from 'react';
import moment from 'moment';
import { FormGroup, Input, Alert } from 'reactstrap';
import {
    FormLabel,
    ValidationErrorMessage,
} from '../common/forms/FormElements';
import { MomentDateFormat } from '../MomentDateFormat';
import EntityContractPhaseManager from './EntityContractPhaseManager';
import { getDurationInDays } from './LongTermSchedule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export default class UnpublishedLongTermScheduleDetails
    extends React.Component
{
    render() {
        const {
            longTermSchedule,
            saving,
            loading,
            contractPhases,
            activeDayCount,
            activeDaysValid,
            onChange,
            onStartDateChange,
            onEndDateChange,
            activeDaysChange,
            onLongTermScheduleContractPhaseChange,
        } = this.props;

        if (!longTermSchedule || longTermSchedule.isPublished) {
            return null;
        }

        // https://stackoverflow.com/a/33352604
        const daysOfWeek = [...Array(7).keys()];

        const durationInDays = getDurationInDays(longTermSchedule);

        const durationAndActiveDaysValid =
            durationInDays > 0 && activeDayCount > 0;

        const diffInDaysColor = durationAndActiveDaysValid
            ? 'success'
            : 'danger';

        const endDateInvalid =
            longTermSchedule.startDate &&
            longTermSchedule.endDate &&
            moment(longTermSchedule.startDate).isAfter(
                longTermSchedule.endDate
            );

        return (
            <>
                <div className="d-flex">
                    <FormGroup className="col-xl-4">
                        <FormLabel text="Start Date" required={true} />
                        <Input
                            id="longTermSchedule.startDate"
                            name="longTermSchedule.startDate"
                            value={
                                moment(longTermSchedule.startDate).format(
                                    MomentDateFormat.DateOnlyUTCHyphenated
                                ) ?? ''
                            }
                            onChange={onStartDateChange}
                            type="date"
                            required={true}
                            disabled={longTermSchedule.isPublished}
                            valid={durationAndActiveDaysValid}
                        />
                        <ValidationErrorMessage>
                            Start Date is required.
                        </ValidationErrorMessage>
                    </FormGroup>

                    <FormGroup className="col-xl-4">
                        <FormLabel text="End Date" required={true} />
                        <Input
                            id="longTermSchedule.endDate"
                            name="longTermSchedule.endDate"
                            value={
                                moment(longTermSchedule.endDate).format(
                                    MomentDateFormat.DateOnlyUTCHyphenated
                                ) ?? ''
                            }
                            onChange={onEndDateChange}
                            type="date"
                            required={true}
                            readOnly={longTermSchedule.isPublished}
                            valid={durationAndActiveDaysValid}
                            invalid={endDateInvalid}
                        />

                        {endDateInvalid && (
                            <small className="text-danger">
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="mr-1"
                                />
                                End Date is required, and must be greater than
                                Start Date.
                            </small>
                        )}
                    </FormGroup>

                    <FormGroup className="col-xl-4">
                        <FormLabel
                            htmlFor="longTermSchedule.isNightShift"
                            text="Night Shift"
                        />
                        <input
                            style={{ width: '50px' }}
                            type="checkbox"
                            className="form-control"
                            id="longTermSchedule.isNightShift"
                            name="longTermSchedule.isNightShift"
                            checked={longTermSchedule.isNightShift}
                            onChange={onChange}
                            disabled={longTermSchedule.isPublished}
                            readOnly={saving || loading}
                        />
                    </FormGroup>
                </div>

                <Alert color={diffInDaysColor} fade={false}>
                    This job is configured to last {durationInDays} days,
                    representing {activeDayCount} days of work.
                </Alert>

                <FormGroup>
                    <FormLabel text="Active Days" required={true} />

                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {daysOfWeek.map((dow, i) => (
                                    <td key={`longTermSchedule.activeDays${i}`}>
                                        <input
                                            type="checkbox"
                                            className="form-control custom-checkbox"
                                            name="longTermSchedule.activeDays"
                                            value={dow}
                                            checked={longTermSchedule.activeDays.includes(
                                                dow
                                            )}
                                            onChange={activeDaysChange}
                                            disabled={
                                                longTermSchedule.isPublished
                                            }
                                            readOnly={saving || loading}
                                        />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>

                    {!activeDaysValid && (
                        <Alert color="danger" fade={false}>
                            One or more days must be selected.
                        </Alert>
                    )}
                </FormGroup>

                <EntityContractPhaseManager
                    contractPhases={contractPhases}
                    entityContractPhases={
                        longTermSchedule.longTermScheduleContractPhases
                    }
                    labelText="Phases - Total For Schedule"
                    onEntityContractPhaseChange={
                        onLongTermScheduleContractPhaseChange
                    }
                    entityId={longTermSchedule.id}
                    showBidTotal
                />
            </>
        );
    }
}
